/**
 * Shared formatting utilities.
 */

/**
 * Converts file size in bytes to human-readable format.
 *
 * @param bytes File size in bytes
 * @param fallback String to return for null/undefined values (default: 'N/A')
 * @returns Formatted string (e.g., "1.5 MB", "250 KB")
 */
export function formatFileSize(bytes: number | null | undefined, fallback = 'N/A'): string {
  if (bytes === null || bytes === undefined) return fallback

  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}

/** Minimal user shape used for display formatting. */
export type UserInfo = {
  external_id?: string
  email?: string
  given_name?: string
  family_name?: string | null
}

/**
 * Format a user's display name from given_name + family_name.
 * Returns empty string if no name parts are available.
 */
export function formatUserName(user: UserInfo | null | undefined): string {
  if (!user) return ''
  return [user.given_name, user.family_name].filter(Boolean).join(' ')
}
